import { Box, Flex, IconButton, Input, InputGroup, InputRightElement } from "@chakra-ui/react";
import AttachmentIcon from "assets/img/support/attachment.svg";
import SenderIcon from "assets/img/support/sender-2.svg";

type Props = {
  draft: string;
  onDraftChange: (value: string) => void;
  onAttach: () => void;
  isUploading: boolean;
  onSend: () => void;
  isSending: boolean;
};

export default function MessageComposer({
  draft,
  onDraftChange,
  onAttach,
  isUploading,
  onSend,
  isSending,
}: Props) {
  return (
    <Flex mt="16px" align="center" w="100%">
      <InputGroup w="100%" _hover={{}}>
        <Input
          value={draft}
          onChange={(e) => onDraftChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey && !isSending) {
              e.preventDefault();
              onSend();
            }
          }}
          placeholder="Type your message..."
          h="48px"
          borderRadius="12px"
          borderColor="#E6ECF3"
          bg="#FFFFFF"
          pr="96px"
          _hover={{}}
        _focus={{ border:"1px solid #2F80ED" }}
        />
        <InputRightElement h="48px" w="96px" pr="8px" pointerEvents="auto">
          <Flex align="center" justify="flex-end" gap="8px" w="100%">
            <IconButton
              aria-label="Attach file"
              onClick={onAttach}
              isLoading={isUploading}
              variant="ghost"
              color="#0B0E10"
              size="sm"
              _hover={{ bg: "transparent" }}
              _active={{ bg: "transparent" }}
              _focusVisible={{ boxShadow: "none" }}
              icon={<Box as="img" src={AttachmentIcon} alt="Attach" w="20px" h="20px" />}
            />
            <IconButton
              aria-label="Send message"
              onClick={() => {
                if (!isSending) onSend();
              }}
              isLoading={isSending}
              isDisabled={isSending}
              colorScheme="blue"
              borderRadius="full"
              h="32px"
              w="32px"
              minW="32px"
              _hover={{ bg: "#2F80ED" , fill: "#2F80ED" }}
              icon={<Box as="img" src={SenderIcon}  alt="Send" w="18px" h="18px" />}
            />
          </Flex>
        </InputRightElement>
      </InputGroup>
    </Flex>
  );
}
